import { Avatar, Box, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import Navbar from "./components/navbar";
import DefaultLayout from "../../layouts/default";
import { Navigate, Outlet } from "react-router-dom";
import { UserProvider, useUser } from "./context/UserContext";
import { useContext } from "react";
import { GlobalContext } from "../../component/GlobalContext";

const UserSettingsTopbar = () => {
  const user = useUser();

  const userIdentifier = user.firstName
    ? `${user.firstName} ${user.lastName || ""}`
    : user.email;

  return (
    <HStack width={"100%"} alignItems={"center"}>
      <Avatar />

      <Heading size={"sm"} m={0}>
        {userIdentifier}{" "}
      </Heading>
      <Text m={0}>({user.nickname})</Text>
    </HStack>
  );
};

const UserSettings = () => {
  const { loggedIn, userInfo} = useContext(GlobalContext)

  if (!loggedIn || userInfo?.user?.role !== "user") {
    return <Navigate to={"/"} replace={true} />;
  }

  return (
    <DefaultLayout withFooter={false}>
      <UserProvider>
        <VStack alignItems={"start"} px={20} gap={"2rem"} pt={5}>
          <UserSettingsTopbar />

          <HStack alignItems={"flex-start"} w={"100%"} gap={"5rem"}>
            <Box>
              <Navbar />
            </Box>
            <Box width={"100%"}>
              <Outlet />
            </Box>
          </HStack>
        </VStack>
      </UserProvider>
    </DefaultLayout>
  );
};

export default UserSettings;
